import React from 'react';
import { useNotifications } from './NotificationProvider';

const typeStyles: Record<string, string> = {
  success: 'bg-emerald-50 border-emerald-200 text-emerald-800',
  error: 'bg-red-50 border-red-200 text-red-800',
  info: 'bg-indigo-50 border-indigo-200 text-indigo-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
};

export const ToastsOverlay: React.FC = () => {
  const { toasts, removeToast } = useNotifications();
  return (
    <div className="fixed z-40 bottom-4 right-4 flex flex-col gap-2">
      {toasts.map(t => (
        <div key={t.id} className={`min-w-[260px] max-w-[380px] px-3 py-2 rounded-xl border shadow-xl/20 shadow-sm backdrop-blur ${typeStyles[t.type]}`}> 
          <div className="flex items-start gap-2">
            <div className="flex-1 text-sm leading-snug">{t.message}</div>
            <button className="text-xs opacity-60 hover:opacity-100" onClick={() => removeToast(t.id)}>Dismiss</button>
          </div>
        </div>
      ))}
    </div>
  );
};
